import React from 'react';
import { Download, FileText } from 'lucide-react';
import { Card, SectionTitle } from '../ui';
import { downloadFile, fmtDateTime } from '../api';

export const STATUS = {
  queued: ['In coda', 'text-[#8A8F97] border-[#1F242C]'],
  running: ['Ricerca in corso', 'text-[#D4AF37] border-[#5A4A17]'],
  captcha: ['Ricerca in corso', 'text-[#D4AF37] border-[#5A4A17]'],
  submitted: ['In preparazione', 'text-[#D4AF37] border-[#5A4A17]'],
  ready: ['Pronta', 'text-green-400 border-green-900'],
  empty: ['Nessun immobile', 'text-[#C9CCD1] border-[#1F242C]'],
  error: ['Non riuscita', 'text-[#E37A72] border-[#5A2420]'],
};

export default function RequestsList({ items }) {
  return (
    <div className="mt-10" data-testid="immobili-requests">
      <SectionTitle>Le mie visure catastali</SectionTitle>
      {!items.length && <p className="text-sm text-[#5A5F67]" data-testid="immobili-requests-empty">Nessuna visura richiesta finora.</p>}
      <div className="space-y-3">
        {items.map((r) => {
          const [label, cls] = STATUS[r.status] || [r.status, ''];
          return (
            <Card key={r.id} className="p-5 flex flex-wrap items-center gap-4" data-testid={`immobili-request-${r.id}`}>
              <FileText size={18} className="text-[#D4AF37] shrink-0" />
              <div className="flex-1 min-w-[200px]">
                <p className="text-sm text-[#F2F2F2] truncate">{r.name}</p>
                <p className="text-xs font-mono text-[#5A5F67]">{r.code} · {fmtDateTime(r.created_at)}</p>
                {r.message && <p className="text-xs text-[#8A8F97] mt-1" data-testid={`immobili-request-message-${r.id}`}>{r.message}</p>}
              </div>
              <span className={`text-[10px] font-mono uppercase tracking-wider px-2 py-1 border rounded-sm ${cls}`} data-testid={`immobili-request-status-${r.id}`}>{label}</span>
              {(r.files || []).map((f) => (
                <button key={f.id} onClick={() => downloadFile(`/property/requests/${r.id}/files/${f.id}`, f.name)} className="h-9 px-3 inline-flex items-center gap-2 border border-[#1F242C] rounded-sm text-xs text-[#E5E5E5] hover:border-[#D4AF37] transition-colors" data-testid={`immobili-download-${f.id}`}>
                  <Download size={14} />{f.name}
                </button>
              ))}
            </Card>
          );
        })}
      </div>
    </div>
  );
}
